import { handleActions } from 'redux-actions'
import * as type from './type'
import { changeTableSettings, createInitialTableState } from '../../../form/state/table-state-helper'


export const initialState = {
    prospectList: [],
    fetching: false,
    error: null,
    ...createInitialTableState({
        sortColumnName: 'created',
        sortOrder: -1,
    }, 'prospectTableSetting'),
}


export default handleActions({
    [type.CHANGE_TABLE_SETTING]: changeTableSettings('prospectTableSetting'),

    [type.FIND_ALL_PROSPECT_REQUEST]: (state, action) => {
        return {
            ...state,
            fetching: true,
            error: null,
        }
    },
    [type.FIND_ALL_PROSPECT_SUCCESS]: (state, action) => {
        const { prospectList } = action.payload
        return {
            ...state,
            prospectList,
            fetching: false,
        }
    },
    [type.FIND_ALL_PROSPECT_ERROR]: (state, action) => {
        const { error } = action.payload
        return {
            ...state,
            fetching: false,
            error,
        }
    },

}, initialState)



// WEBPACK FOOTER //
// ./src/modules/prospect/state/search/reducer.js